import axios from "axios";
import { ACTIVE_API_PATH } from "../constants/workerConstants";
import { getApiPrefix } from "../utils/apiPrefix";
import { store } from "../redux/store";

// Configure baseURL based on environment
const baseURL = process.env.NODE_ENV === 'production' 
  ? '' // Empty string for relative URLs in production
  : ACTIVE_API_PATH; // Use absolute URL in development

const AxiosInstance = axios.create({
  baseURL: baseURL,
  timeout: -1,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Include credentials by default
});

// Add request interceptor to handle API prefixing and token attachment
AxiosInstance.interceptors.request.use(config => {
  // If URL starts with '/' and doesn't already include the environment-specific prefix
  const prefix = getApiPrefix();
  if (config.url && config.url.startsWith('/') && !config.url.startsWith(prefix)) {
    // Fix the URL by replacing the leading '/' with the appropriate prefix
    config.url = prefix + config.url.substring(1);
  }
  
  // Attach token to Authorization header from Redux store
  try {
    const state = store.getState();
    const token = state.user?.authToken;
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (error) {
    // If token extraction fails, continue without token
    console.error('Failed to extract auth token:', error);
  }
  
  return config;
}, error => {
  return Promise.reject(error);
});

AxiosInstance.interceptors.response.use(
  (response) => ({
    status: true,
    message: response.status,
    data: response.data,
  }),
  (error) => {
    // Handle 401 Unauthorized - token is invalid/expired
    // Don't logout if it's the login endpoint itself failing
    const isLoginEndpoint = error.config?.url?.includes('Signin/Login');
    
    if (error.response?.status === 401 && !isLoginEndpoint) {
      // Clear all stored auth data
      localStorage.clear();
      
      // Redirect to login page
      window.location.href = '/';
      
      return {
        status: false,
        message: 'Session expired. Please login again.',
      };
    }
    
    return {
      status: false,
      message: error,
    };
  }
);

export default AxiosInstance;
